import React, { Dispatch, SetStateAction, useState } from 'react';
import {Box, Button, Dialog, DialogActions, DialogTitle, OutlinedInput, Typography} from '@mui/material';
import {closeBtn, dialogActions, dialogTitle, paperProps, title, deleteBtn, inputInfo, titleBox} from './EmailModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import DialogContent from "@mui/material/DialogContent";
import useEmailModal from "app/components/EmailModal/useEmailModal";
import {secondaryDefault} from "app/components/ThemeProvider/colors";
import FieldError from "app/components/FieldError";

interface Props {
    open: boolean;
    close: Dispatch<SetStateAction<boolean>>;
    headerText: string;
    setEmailInput: (val: string) => void;
    emailInput: string;
    handleSubmit?: () => void;
    errorMessage?: string;
}

const EmailModal = (props: Props) => {
    const { open, close, headerText,setEmailInput,emailInput,handleSubmit ,errorMessage} = props;


    const {t} = useEmailModal();

    const handleChangeEmail = (event:  React.ChangeEvent<HTMLInputElement>) => {
        setEmailInput(event.target.value);
    };

    return (
        <>
            <Dialog
                open={open}
                PaperProps={{
                    sx: paperProps,
                }}
                onClose={() => close(false)}
            >
                <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
                    <Box sx={titleBox}>
                        <Typography sx={title}>{headerText}</Typography>
                        <Button
                            color={'tertiary'}
                            onClick={() => {
                                close(false);
                            }}
                            sx={closeBtn}
                        >
                            <CloseIcon />
                        </Button>
                    </Box>
                    <Typography sx={{color: secondaryDefault}}>
                        Məlumat çoxluğu səbəbindən çıxarışınız e-mail ünvanına göndərilə bilər.
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{p: '0px 40px 0px 40px' }}>
                    <Box>
                        <Typography sx={inputInfo}>Email</Typography>
                        <Box sx={{  mb: '24px',

                            '@media screen and (max-height: 864px)': {
                                mb: '20px',
                            }}}>
                            <OutlinedInput
                                type={'email'}
                                placeholder={t('recovery.email')}
                                value={emailInput}
                                sx={{
                                    width: '100%',
                                    pl: '16px',

                                }}
                                inputProps={{
                                    style: { paddingLeft: '0' },
                                }}
                                onChange={handleChangeEmail}
                                error={errorMessage.length > 0}
                            />
                            <FieldError
                                error={{message: errorMessage}}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={dialogActions}>
                    <Button
                        disabled={emailInput?.length === 0}
                        onClick={handleSubmit}
                    >
                        Göndər
                    </Button>
                    <Button
                        color={'secondary'}
                        sx={{ ml: '0 !important' }}
                        onClick={() => {
                            close(false);
                        }}
                    >
                        Bağla
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EmailModal;
